import { CheckCheck } from "lucide-react"
import { ReactNode, useCallback, useEffect, useState } from "react"

import { OSLoader } from "~/components/base-loader"
import { sleep } from "~/utils/sleep"

export default function RootAgentUI({
  tenantName,
  commonTranslations
}: {
  tenantName: string
  commonTranslations: any
}) {
  const [steps, setSteps] = useState<
    { title: ReactNode; children?: { title: ReactNode }[] }[]
  >([])
  const [currentStep, setCurrentStep] = useState({ parent: 0, child: 0 })
  const initializeSteps = useCallback(async () => {
    const stepsValues = [
      {
        title: (
          <p className="text-13 dark:text-dark-6 text-dark-2">
            {commonTranslations?.label_rootAgentUiTitle1}
          </p>
        )
      },
      {
        title: (
          <p className="text-13 dark:text-dark-6 text-dark-2">
            {commonTranslations?.label_rootAgentUiTitle2}{" "}
            <strong className="text-primary dark:text-primary-light">
              {tenantName}
            </strong>
          </p>
        )
      },
      {
        title: (
          <p className="text-13 dark:text-dark-6 text-dark-2">
            {commonTranslations?.label_rootAgentUiTitle3}
          </p>
        )
      }
    ]
    for (let i = 0; i < stepsValues.length; i++) {
      const { promise, clear } = sleep(400 * i)
      await promise
      clear()
      const _previousSteps = stepsValues.slice(0, i)
      const currentStep = {
        ...stepsValues[i],
        children: [] as any[]
      }
      setSteps([..._previousSteps, currentStep])
      setCurrentStep({ parent: i + 1, child: 0 })
    }
  }, [
    commonTranslations?.label_rootAgentUiTitle1,
    commonTranslations?.label_rootAgentUiTitle2,
    commonTranslations?.label_rootAgentUiTitle3,
    tenantName
  ])

  useEffect(() => {
    initializeSteps()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ul className="flex flex-col gap-4" data-testid="root-agent-ui">
      {steps.map((step, index) => (
        <li
          key={index}
          className="text-xs flex flex-col gap-2"
          data-testid={`root-agent-ui-step-${index}`}
        >
          <div className="flex gap-2 items-center">
            {index + 1 < currentStep.parent ? (
              <div className="w-5 h-5 rounded-full flex items-center justify-center bg-primary">
                <CheckCheck size={16} color="#fff" />
              </div>
            ) : (
              <OSLoader className="xs" />
            )}
            <span>{step.title}</span>
          </div>
        </li>
      ))}
    </ul>
  )
}
